(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("@splat/theme"), require("@splat/iconfont"), require("@splat/menu"), require("@splat/inject-flash"), require("@splat/operation-zone"), require("@splat/dropdown"), require("core-js/modules/esnext.global-this.js"), require("vuex"), require("vuex-class"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("@splat/dialog"), require("@splat/form"), require("@splat/form-item"), require("@splat/button"), require("@splat/input"), require("@splat/status"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , , "core-js/modules/esnext.global-this.js", , , , , , , , , , , , , ], factory);
	else if(typeof exports === 'object')
		exports["navbar"] = factory(require("@splat/constant"), require("@splat/theme"), require("@splat/iconfont"), require("@splat/menu"), require("@splat/inject-flash"), require("@splat/operation-zone"), require("@splat/dropdown"), require("core-js/modules/esnext.global-this.js"), require("vuex"), require("vuex-class"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("@splat/dialog"), require("@splat/form"), require("@splat/form-item"), require("@splat/button"), require("@splat/input"), require("@splat/status"));
	else
		root["navbar"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE__splat_iconfont__, __WEBPACK_EXTERNAL_MODULE__splat_menu__, __WEBPACK_EXTERNAL_MODULE__splat_inject_flash__, __WEBPACK_EXTERNAL_MODULE__splat_operation_zone__, __WEBPACK_EXTERNAL_MODULE__splat_dropdown__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__, __WEBPACK_EXTERNAL_MODULE_vuex__, __WEBPACK_EXTERNAL_MODULE_vuex_class__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__, __WEBPACK_EXTERNAL_MODULE__splat_dialog__, __WEBPACK_EXTERNAL_MODULE__splat_form__, __WEBPACK_EXTERNAL_MODULE__splat_form_item__, __WEBPACK_EXTERNAL_MODULE__splat_button__, __WEBPACK_EXTERNAL_MODULE__splat_input__, __WEBPACK_EXTERNAL_MODULE__splat_status__) {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    navbar: {
      confirm: 'Are you sure jump',
      cancel: 'Function not enabled, please setting',
      more: 'More'
    }
  },
  'zh-CHT': {
    navbar: {
      confirm: "\u78BA\u5B9A\u8981\u8DF3\u8F49\u55CE",
      cancel: "\u529F\u80FD\u672A\u958B\u555F\uFF0C\u8ACB\u8A2D\u7F6E\u66F4\u6539",
      more: "\u66F4\u591A"
    }
  },
  'zh-CN': {
    navbar: {
      confirm: "\u786E\u5B9A\u8981\u8DF3\u8F6C\u5417",
      cancel: "\u529F\u80FD\u672A\u5F00\u542F\uFF0C\u8BF7\u8BBE\u7F6E\u66F4\u6539",
      more: "\u66F4\u591A"
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/logo.tsx":
/*!**********************!*\
  !*** ./src/logo.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jsonp": function() { return /* binding */ jsonp; },
/* harmony export */   "centerTextStyleClassName": function() { return /* binding */ centerTextStyleClassName; },
/* harmony export */   "logoContentClassName": function() { return /* binding */ logoContentClassName; },
/* harmony export */   "logoContentInvertClassName": function() { return /* binding */ logoContentInvertClassName; },
/* harmony export */   "logoWrapperClassName": function() { return /* binding */ logoWrapperClassName; },
/* harmony export */   "CenterText": function() { return /* binding */ CenterText; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/inject-flash */ "@splat/inject-flash");
/* harmony import */ var _splat_inject_flash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_dialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/dialog */ "@splat/dialog");
/* harmony import */ var _splat_dialog__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_dialog__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/form */ "@splat/form");
/* harmony import */ var _splat_form__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_form__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @splat/form-item */ "@splat/form-item");
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_splat_form_item__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _splat_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @splat/button */ "@splat/button");
/* harmony import */ var _splat_button__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_splat_button__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @splat/input */ "@splat/input");
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_splat_input__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _splat_status__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @splat/status */ "@splat/status");
/* harmony import */ var _splat_status__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_splat_status__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _asset_splat_png__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./asset/splat.png */ "./src/asset/splat.png");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_21__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};















function jsonp(url) {
  var script = document.createElement('script');
  script.style.visibility = 'hidden';
  script.style.zIndex = '-1';

  script.onerror = function () {};

  script.src = "".concat(url);
  setTimeout(function () {
    document.body.appendChild(script);
  });
}
var centerTextStyleClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.style)({
  textAlign: 'center',
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_15__.CommonColors.normalText.toString()
});
var logoContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_20__.px)(140),
  verticalAlign: 'middle'
});
var logoContentInvertClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.style)({
  filter: 'invert(1)'
});
var logoWrapperClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.style)(csstips__WEBPACK_IMPORTED_MODULE_21__.fillParent, csstips__WEBPACK_IMPORTED_MODULE_21__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_21__.centerCenter, {});

var CenterText = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__["default"])(CenterText, _tsx$Component);

  var _super = _createSuper(CenterText);

  function CenterText() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__["default"])(this, CenterText);

    return _super.apply(this, arguments);
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__["default"])(CenterText, [{
    key: "render",
    value: function render(h) {
      return h("div", {
        "class": centerTextStyleClassName
      }, [this.$slots.default]);
    }
  }]);

  return CenterText;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_18__.Component);

CenterText = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__.Component], CenterText);


var Logo = /*#__PURE__*/function (_tsx$Component2) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__["default"])(Logo, _tsx$Component2);

  var _super2 = _createSuper(Logo);

  function Logo() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__["default"])(this, Logo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "logo", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "logoClassName", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "group", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "invert", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "jsonp", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "counter", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "showConfirm", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "showConnect", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "showTerminal", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "localWs", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "remoteWs", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "localBuffer", []);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "remoteBuffer", []);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "jsonpOrWsAddr", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_0__["default"])(_this), "handleTimeout", (0,_splat_constant__WEBPACK_IMPORTED_MODULE_15__.debounce)(function () {
      _this.counter = 0;
    }, 10 * 1000));

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__["default"])(Logo, [{
    key: "handleClick",
    value: function handleClick() {
      this.counter++;

      if (this.counter >= 8) {
        this.counter = 0;
        this.handleShowStartRemote();
      } else {
        this.handleTimeout();
      }
    }
  }, {
    key: "handleShowStartRemote",
    value: function handleShowStartRemote() {
      this.showConnect = this.showTerminal = false;
      this.showConfirm = true;
    }
  }, {
    key: "handleConfirmClose",
    value: function handleConfirmClose() {
      this.showConfirm = false;
    }
  }, {
    key: "handleConnectClose",
    value: function handleConnectClose() {
      this.handleTerminal();
    }
  }, {
    key: "handleShowTerminal",
    value: function handleShowTerminal() {
      this.showTerminal = true;
    }
  }, {
    key: "handleTerminal",
    value: function handleTerminal() {
      this.showConnect = false;
      this.cleanUp(1000, '');
      (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_success)('远程协助已终止');
    }
  }, {
    key: "handleTerminalCancel",
    value: function handleTerminalCancel() {
      this.showTerminal = false;
    }
  }, {
    key: "handleStartRemote",
    value: function handleStartRemote() {
      var _this2 = this;

      var local = "".concat(window.location.protocol === 'https:' ? 'wss' : 'ws', "://").concat(window.location.host, "/api/ws");
      (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_info)('正在建立远程连接');
      var anyWindow = window;

      anyWindow.setRemoteAssistant = function (_ref) {
        var url = _ref.url;
        return _this2.setupPipeline(local, url);
      };

      if (!this.jsonpOrWsAddr) {
        (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_error)('请输入远程协助地址');
      } else {
        if (this.jsonpOrWsAddr.startsWith('ws')) {
          this.setupPipeline(local, this.jsonpOrWsAddr);
        } else {
          jsonp(this.jsonpOrWsAddr);
        }

        this.showConfirm = false;
      }
    }
  }, {
    key: "cleanUp",
    value: function cleanUp(code, reason) {
      if (this.localWs) {
        this.localWs.close(code, reason);
        this.localWs = null;
      }

      if (this.remoteWs) {
        this.remoteWs.close(code, reason);
        this.localWs = null;
      }
    }
  }, {
    key: "send",
    value: function send() {
      var localWs = this.localWs,
          localBuffer = this.localBuffer,
          remoteWs = this.remoteWs,
          remoteBuffer = this.remoteBuffer;

      if (localWs && localWs.readyState === 1 && remoteWs && remoteWs.readyState === 1) {
        while (localBuffer.length) {
          remoteWs.send(localBuffer.shift());
        }

        while (remoteBuffer.length) {
          localWs.send(remoteBuffer.shift());
        }
      }
    }
  }, {
    key: "open",
    value: function open() {
      var localWs = this.localWs,
          remoteWs = this.remoteWs;

      if (localWs && localWs.readyState === 1 && remoteWs && remoteWs.readyState === 1) {
        (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_success)('远程协助已开始');
        this.showConnect = true;
        this.send();
      }
    }
  }, {
    key: "setupPipeline",
    value: function setupPipeline(local, remote) {
      var _this3 = this;

      var localWs = this.localWs = new WebSocket(local, 'assist');
      var remoteWs = this.remoteWs = new WebSocket("".concat(remote, "?group=").concat(this.group));
      localWs.binaryType = remoteWs.binaryType = 'arraybuffer';

      localWs.onclose = function (ev) {
        (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_error)("\u670D\u52A1\u7AEF\u8FDE\u63A5\u5173\u95ED ".concat(ev.reason)); // eslint-disable-next-line no-console

        console.dir(ev);

        _this3.cleanUp(1000, 'local closed');
      };

      localWs.onerror = function (ev) {
        (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_error)("\u670D\u52A1\u7AEF\u8FDE\u63A5\u51FA\u9519 ".concat(JSON.stringify(ev))); // eslint-disable-next-line no-console

        console.dir(ev);

        _this3.cleanUp(1000, 'local errored');
      };

      remoteWs.onclose = function (ev) {
        (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_error)("\u8FDC\u7AEF\u8FDE\u63A5\u5173\u95ED ".concat(ev.reason)); // eslint-disable-next-line no-console

        console.dir(ev);

        _this3.cleanUp(1000, 'remote closed');
      };

      remoteWs.onerror = function (ev) {
        (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_8__.$_error)("\u8FDC\u7AEF\u8FDE\u63A5\u51FA\u9519 ".concat(JSON.stringify(ev))); // eslint-disable-next-line no-console

        console.dir(ev);

        _this3.cleanUp(1000, 'remote errored');
      };

      localWs.onopen = remoteWs.onopen = function () {
        _this3.open();
      };

      localWs.onmessage = function (msg) {
        _this3.localBuffer.push(msg.data);

        _this3.send();
      };

      remoteWs.onmessage = function (msg) {
        _this3.remoteBuffer.push(msg.data);

        _this3.send();
      };
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this4 = this;

      var logo = this.logo,
          invert = this.invert,
          showConfirm = this.showConfirm,
          showConnect = this.showConnect,
          showTerminal = this.showTerminal,
          logoClassName = this.logoClassName,
          handleStartRemote = this.handleStartRemote,
          handleConfirmClose = this.handleConfirmClose,
          handleClick = this.handleClick,
          handleShowTerminal = this.handleShowTerminal,
          handleTerminal = this.handleTerminal,
          handleTerminalCancel = this.handleTerminalCancel;
      return h("div", {
        "class": logoWrapperClassName
      }, [h("img", {
        "on": {
          "click": handleClick
        },
        "attrs": {
          "src": logo
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(logoClassName || logoContentClassName, invert && logoContentInvertClassName)
      }), h((_splat_dialog__WEBPACK_IMPORTED_MODULE_9___default()), {
        "attrs": {
          "title": '远程协助',
          "value": showConfirm,
          "closeOnClickModal": false
        },
        "on": {
          "input": function input(v) {
            return _this4.showConfirm = v;
          }
        }
      }, [h("el-row", [h("el-col", [h(CenterText, ["\u662F\u5426\u5F00\u542F\u8FDC\u7A0B\u534F\u52A9\u529F\u80FD"]), h((_splat_form_item__WEBPACK_IMPORTED_MODULE_11___default()), {
        "attrs": {
          "label": '远程协助地址'
        }
      }, [h((_splat_input__WEBPACK_IMPORTED_MODULE_13___default()), {
        "attrs": {
          "value": this.jsonpOrWsAddr || ''
        },
        "on": {
          "input": function input(v) {
            return _this4.jsonpOrWsAddr = v;
          }
        }
      })])])]), h("span", {
        "slot": 'footer'
      }, [h((_splat_button__WEBPACK_IMPORTED_MODULE_12___default()), {
        "on": {
          "click": handleConfirmClose
        }
      }, ["\u53D6 \u6D88"]), h((_splat_button__WEBPACK_IMPORTED_MODULE_12___default()), {
        "attrs": {
          "type": _splat_button__WEBPACK_IMPORTED_MODULE_12__.Type.primary
        },
        "on": {
          "click": handleStartRemote
        }
      }, ["\u786E \u5B9A"])])]), h((_splat_dialog__WEBPACK_IMPORTED_MODULE_9___default()), {
        "attrs": {
          "title": '远程协助',
          "value": showConnect,
          "closeOnClickModal": false,
          "showClose": false
        },
        "on": {
          "input": function input(v) {
            return _this4.showConnect = v;
          }
        }
      }, [h((_splat_form__WEBPACK_IMPORTED_MODULE_10___default()), [h((_splat_form_item__WEBPACK_IMPORTED_MODULE_11___default()), [h((_splat_status__WEBPACK_IMPORTED_MODULE_14___default()), {
        "attrs": {
          "type": _splat_status__WEBPACK_IMPORTED_MODULE_14__.StatusType.lineWarning
        }
      }, ["\u5728\u8FDC\u7A0B\u534F\u52A9\u4E2D\uFF0C\u8BF7\u52FF\u968F\u610F\u5237\u65B0\uFF0C\u9000\u51FA\u9875\u9762\u4EE5\u53CA\u5173\u95ED\u9875\u9762\uFF0C\u8BF7\u4E0E\u6280\u672F\u5DE5\u7A0B\u5E08\u786E\u8BA4\u540E\u518D\u9000\u51FA\u8FDC\u7A0B\u534F\u52A9\uFF0C\u8FDC\u7A0B\u534F\u52A9\u6A21\u5F0F\u4E2D\u610F\u5916\u9000\u51FA\u4F1A\u5BFC\u81F4\u8FDC\u7A0B\u534F\u52A9\u4E2D\u65AD\uFF0C\u53EF\u80FD\u5BF9\u7CFB\u7EDF\u9020\u6210\u5F71\u54CD"])])]), h("el-row", [h("el-col", [h(CenterText, ["\u8FDC\u7A0B\u534F\u52A9\u6B63\u5728\u8FDB\u884C\u4E2D\uFF0C\u8BF7\u52FF\u5173\u95ED\u672C\u9875\u9762..."])])]), showTerminal ? h("el-row", [h("el-col", [h(CenterText, ["\u662F\u5426\u7ACB\u5373\u9000\u51FA\u8FDC\u7A0B\u534F\u52A9?"])])]) : null, h("span", {
        "slot": 'footer'
      }, [showTerminal ? h("span", [h((_splat_button__WEBPACK_IMPORTED_MODULE_12___default()), {
        "on": {
          "click": handleTerminalCancel
        }
      }, ["\u53D6 \u6D88"]), h((_splat_button__WEBPACK_IMPORTED_MODULE_12___default()), {
        "attrs": {
          "type": _splat_button__WEBPACK_IMPORTED_MODULE_12__.Type.error
        },
        "on": {
          "click": handleTerminal
        }
      }, ["\u7ED3 \u675F"])]) : h("span", [h((_splat_button__WEBPACK_IMPORTED_MODULE_12___default()), {
        "attrs": {
          "type": _splat_button__WEBPACK_IMPORTED_MODULE_12__.Type.primary
        },
        "on": {
          "click": handleShowTerminal
        }
      }, ["\u7ED3\u675F\u8FDC\u7A0B\u534F\u52A9"])])])])]);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.jsonpOrWsAddr = this.jsonp;
    }
  }]);

  return Logo;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_18__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__.Prop)({
  default: function _default() {
    return _asset_splat_png__WEBPACK_IMPORTED_MODULE_16__;
  }
})], Logo.prototype, "logo", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__.Prop)({
  default: function _default() {
    return undefined;
  }
})], Logo.prototype, "logoClassName", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__.Prop)({
  default: function _default() {
    return 'splat';
  }
})], Logo.prototype, "group", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__.Prop)({
  default: function _default() {
    return false;
  }
})], Logo.prototype, "invert", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__.Prop)({
  default: function _default() {
    return 'https://support.chaitin.cn/safeline/remote_assistance';
  }
})], Logo.prototype, "jsonp", void 0);

Logo = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_17__.Component], Logo);
/* harmony default export */ __webpack_exports__["default"] = (Logo);

/***/ }),

/***/ "./src/navbar.tsx":
/*!************************!*\
  !*** ./src/navbar.tsx ***!
  \************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @splat/iconfont */ "@splat/iconfont");
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_splat_iconfont__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _splat_menu__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @splat/menu */ "@splat/menu");
/* harmony import */ var _splat_menu__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_splat_menu__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _splat_inject_flash__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @splat/inject-flash */ "@splat/inject-flash");
/* harmony import */ var _splat_inject_flash__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_splat_inject_flash__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _splat_operation_zone__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @splat/operation-zone */ "@splat/operation-zone");
/* harmony import */ var _splat_operation_zone__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_splat_operation_zone__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _splat_dropdown__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @splat/dropdown */ "@splat/dropdown");
/* harmony import */ var _splat_dropdown__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_splat_dropdown__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./store */ "./src/store/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_21__);










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var Navbar = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__["default"])(Navbar, _tsx$Component);

  var _super = _createSuper(Navbar);

  function Navbar() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__["default"])(this, Navbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "navbarConfig", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "statusOpen", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "minorMenuAppend", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "stripFirst", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "hideMinorMenu", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "hideMajorMenu", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "hideZone", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "minorMenuShrink", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "minorMaxWidth", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "minorMenuShrinkButton", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "minorStatusText", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "statusSettingPath", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "more", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "aItem", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "filterWhiteBkg", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "beforePushRoute", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "selectedMajorMenuIndex", '');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "selectedMinorMenuIndex", '');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "selectedSubMenuIndex", '');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "reloading", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "minorMenuActive", true);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "minorButtonHover", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "beforePushRouteRunning", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_16__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__["default"])(Navbar, [{
    key: "onMenuShrinked",
    value: function onMenuShrinked() {
      return this.minorMenuShrink ? true : false;
    }
  }, {
    key: "handleRouteChanged",
    value: function handleRouteChanged() {
      var name = this.$route.name || '';

      var _name$split = name.split(':'),
          _name$split2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_name$split, 3),
          major = _name$split2[0],
          minor = _name$split2[1],
          submenu = _name$split2[2];

      this.selectedMajorMenuIndex = major || '';
      this.selectedMinorMenuIndex = "".concat(major, ":").concat(minor || '');
      this.selectedSubMenuIndex = [major, minor, submenu].filter(Boolean).join(':');
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this2 = this;

      this.reloading = true;
      this.$nextTick(function () {
        return _this2.reloading = false;
      });
    }
  }, {
    key: "reloadRouterView",
    value: function reloadRouterView() {
      return this.reload;
    }
  }, {
    key: "minorWidth",
    get: function get() {
      var minorMaxWidth = this.minorMaxWidth,
          theme = this.theme,
          i18nInjection = this.i18nInjection;
      return minorMaxWidth ? _splat_constant__WEBPACK_IMPORTED_MODULE_9__.MenuSizes.minorMaxWidth : _splat_constant__WEBPACK_IMPORTED_MODULE_9__.MenuSizes.themeMinorWidth(theme, i18nInjection.lang);
    }
  }, {
    key: "majorMenus",
    get: function get() {
      return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.keyBy)(this.navbarConfig, 'name');
    }
  }, {
    key: "minorMenus",
    get: function get() {
      return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.keyBy)(this.selectedMajorMenu && this.selectedMajorMenu.children || [], 'name');
    }
  }, {
    key: "selectedMajorMenu",
    get: function get() {
      return this.majorMenus[this.selectedMajorMenuIndex];
    }
  }, {
    key: "selectedMinorMenu",
    get: function get() {
      return this.minorMenus[this.selectedMinorMenuIndex];
    }
  }, {
    key: "pushRoute",
    value: function pushRoute(to, rcb) {
      var _this$beforePushRoute,
          _this3 = this;

      this.beforePushRouteRunning = true;
      var beforePushRoute = (_this$beforePushRoute = this.beforePushRoute) !== null && _this$beforePushRoute !== void 0 ? _this$beforePushRoute : function (a) {
        return a;
      };
      Promise.resolve(beforePushRoute(to)).then(function (r) {
        if (!r) return;
        (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.routerPushOrReplace)(_this3.$router, 'push', r);
        rcb ? rcb() : undefined;
      }).finally(function () {
        _this3.beforePushRouteRunning = false;
      }).catch(function (err) {
        if (!(err === 'cancel')) {
          throw Error(err);
        }
      });
    }
  }, {
    key: "handleMajorMenuSelectedChanged",
    value: function handleMajorMenuSelectedChanged(index) {
      var _this4 = this;

      if (this.beforePushRouteRunning) return;

      var cb = function cb() {
        _this4.selectedMajorMenuIndex = index;
      };

      var toMajor = this.majorMenus[index];

      if (toMajor && toMajor.children) {
        (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.maybeFirst)(toMajor.children).map(function (x) {
          return x.name;
        }).map(function (x) {
          _this4.handleMinorMenuSelectedChanged(x, cb);
        });
      } else {
        this.pushRoute({
          name: index
        }, cb);
      }
    }
  }, {
    key: "handleMinorMenuSelectedChanged",
    value: function handleMinorMenuSelectedChanged(index, rcb, config) {
      var _this5 = this;

      var renderConfirm = this.renderConfirm;
      if (this.beforePushRouteRunning) return;

      if (config && config.status && !this.statusOpen.includes(config.name)) {
        renderConfirm(config, false);
        return;
      }

      var cb = function cb() {
        rcb ? rcb() : null;
        _this5.selectedMinorMenuIndex = index;
      };

      var toMinor = this.minorMenus[index];

      if (toMinor && toMinor.children) {
        (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.maybeFirst)(toMinor.children).map(function (x) {
          return x.name;
        }).map(function (x) {
          _this5.handleSubMenuSelectedChanged(x, cb);
        });
      } else {
        this.pushRoute({
          name: index
        }, cb);
      }
    }
  }, {
    key: "handleSubMenuSelectedChanged",
    value: function handleSubMenuSelectedChanged(index, rcb, config) {
      var _this6 = this;

      if (this.beforePushRouteRunning) return;

      if (config && config.status && !this.statusOpen.includes(config.name)) {
        this.renderConfirm(config, false);
        return;
      }

      this.pushRoute({
        name: index
      }, function () {
        rcb ? rcb() : null;
        _this6.selectedSubMenuIndex = index;
      });
    }
  }, {
    key: "handleBeforeEnter",
    value: function handleBeforeEnter(e) {
      var el = e;
      el.style.cssText += "left:-".concat(this.minorWidth, ";width:0px");
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(e, done) {
      var _this7 = this;

      setTimeout(function () {
        var el = e;
        el.style.cssText += "left:0px;width:".concat(_this7.minorWidth, "px");
      }, 0);
      e.addEventListener('transitioned', done, {
        once: true
      });
    }
  }, {
    key: "handleBeforeLeave",
    value: function handleBeforeLeave(e) {}
  }, {
    key: "handleLeave",
    value: function handleLeave(e, done) {
      var _this8 = this;

      setTimeout(function () {
        var el = e;
        el.style.cssText += "left:-".concat(_this8.minorWidth, "px;width:0px");
      }, 0);
      e.addEventListener('transitioned', done, {
        once: true
      });
    }
  }, {
    key: "handleMoveMinorMenu",
    value: function handleMoveMinorMenu() {
      var _this9 = this;

      this.minorMenuActive = !this.minorMenuActive;
      setTimeout(function () {
        _this9.onMenuShrinked();
      }, 250);
    }
  }, {
    key: "handleMouseenter",
    value: function handleMouseenter() {
      this.minorButtonHover = true;
    }
  }, {
    key: "handleMouseleave",
    value: function handleMouseleave() {
      this.minorButtonHover = false;
    }
  }, {
    key: "handleClickStatus",
    value: function handleClickStatus(e, config) {
      e.stopPropagation();
      e.preventDefault();
      this.renderConfirm(config, this.statusOpen.includes(config.name));
    }
  }, {
    key: "renderConfirm",
    value: function renderConfirm(config) {
      var _this10 = this;

      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var minorStatusText = this.minorStatusText,
          statusSettingPath = this.statusSettingPath,
          beforePushRouteRunning = this.beforePushRouteRunning;
      if (!config.status || beforePushRouteRunning || !statusSettingPath) return;
      var text = status ? config.confirmText ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(config.confirmText) : "".concat(this.i18n.t.navbar.confirm, "?") : config.cancelText ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(config.cancelText) : this.i18n.t.navbar.cancel;
      var cancel = status ? minorStatusText === null || minorStatusText === void 0 ? void 0 : minorStatusText.openCancel : minorStatusText === null || minorStatusText === void 0 ? void 0 : minorStatusText.closeCancel;
      var ok = status ? minorStatusText === null || minorStatusText === void 0 ? void 0 : minorStatusText.openOk : minorStatusText === null || minorStatusText === void 0 ? void 0 : minorStatusText.closeOk;
      (0,_splat_inject_flash__WEBPACK_IMPORTED_MODULE_13__.confirm)(text, cancel ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(cancel) : undefined, ok ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(ok) : undefined).then(function () {
        var resolve = _this10.$router.resolve(statusSettingPath);

        window.open(resolve.href, '_blank');
      }).catch(function (err) {
        if (!(err === 'cancel')) {
          throw Error(err);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      var h = arguments[0];
      var navbarConfig = this.navbarConfig,
          stripFirst = this.stripFirst,
          selectedMajorMenuIndex = this.selectedMajorMenuIndex,
          selectedMinorMenuIndex = this.selectedMinorMenuIndex,
          selectedSubMenuIndex = this.selectedSubMenuIndex,
          selectedMajorMenu = this.selectedMajorMenu,
          handleMajorMenuSelectedChanged = this.handleMajorMenuSelectedChanged,
          handleMinorMenuSelectedChanged = this.handleMinorMenuSelectedChanged,
          handleSubMenuSelectedChanged = this.handleSubMenuSelectedChanged,
          hideMajorMenu = this.hideMajorMenu,
          hideMinorMenu = this.hideMinorMenu,
          hideZone = this.hideZone,
          reloading = this.reloading,
          minorMenuAppend = this.minorMenuAppend,
          minorMenuActive = this.minorMenuActive,
          minorMenuShrink = this.minorMenuShrink,
          minorMaxWidth = this.minorMaxWidth,
          minorMenuShrinkButton = this.minorMenuShrinkButton,
          statusOpen = this.statusOpen,
          handleClickStatus = this.handleClickStatus,
          more = this.more,
          aItem = this.aItem,
          majorMenus = this.majorMenus,
          minorMenus = this.minorMenus,
          filterWhiteBkg = this.filterWhiteBkg,
          theme = this.theme,
          i18nInjection = this.i18nInjection;

      var majorMenuItem = function majorMenuItem() {
        return navbarConfig.slice(0, navbarConfig.length - more).map(function (config, i) {
          var _majorMenus$config$na;

          return !config.hide ? h(_splat_menu__WEBPACK_IMPORTED_MODULE_12__.Item, {
            "key": i,
            "attrs": {
              "index": config.name,
              "aItem": aItem,
              "firstChild": (_majorMenus$config$na = majorMenus[config.name].children) !== null && _majorMenus$config$na !== void 0 && _majorMenus$config$na.length ? majorMenus[config.name].children[0].name : undefined,
              "actived": config.name === selectedMajorMenuIndex
            },
            "on": {
              "click": function click(i) {
                return handleMajorMenuSelectedChanged(i);
              }
            }
          }, [config.icon ? h("i", {
            "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.iconClassName, config.icon)
          }) : null, h("span", [(0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(config.title)])]) : null;
        });
      };

      var majorMoreMenuItem = function majorMoreMenuItem() {
        return more ? h((_splat_dropdown__WEBPACK_IMPORTED_MODULE_15___default()), {
          "attrs": {
            "trigger": _splat_dropdown__WEBPACK_IMPORTED_MODULE_15__.Trigger.hover
          },
          "on": {
            "command": handleMajorMenuSelectedChanged
          },
          "class": _style__WEBPACK_IMPORTED_MODULE_18__.majorMoreMenuItemClassName,
          "scopedSlots": {
            visible: function visible(v) {
              return h("div", {
                "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.majorMoreActivityClassName, v.visible ? _style__WEBPACK_IMPORTED_MODULE_18__.visibleDropClassName : null)
              }, [h("span", [_this11.i18n.t.navbar.more]), h("i", {
                "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('iconfont icon-dropdown', _style__WEBPACK_IMPORTED_MODULE_18__.majorMoreDropIconClassName)
              })]);
            }
          }
        }, [h(_splat_dropdown__WEBPACK_IMPORTED_MODULE_15__.DropdownMenu, {
          "slot": 'dropdown'
        }, [navbarConfig.slice(navbarConfig.length - more).map(function (config, i) {
          return !config.hide ? h(_splat_dropdown__WEBPACK_IMPORTED_MODULE_15__.DropdownItem, {
            "attrs": {
              "command": config.name
            },
            "class": _style__WEBPACK_IMPORTED_MODULE_18__.majorMoreDropItemClassName
          }, [config.icon ? h("i", {
            "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.iconClassName, config.icon)
          }) : null, h("span", [(0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(config.title)])]) : null;
        })])]) : null;
      };

      var minorMenuItem = function minorMenuItem() {
        return selectedMajorMenu && selectedMajorMenu.children && selectedMajorMenu.children.map(function (config, i) {
          var _minorMenus$config$na;

          return !config.hide ? h(_splat_menu__WEBPACK_IMPORTED_MODULE_12__.Item, {
            "key": i,
            "attrs": {
              "index": config.name,
              "aItem": aItem,
              "firstChild": (_minorMenus$config$na = minorMenus[config.name].children) !== null && _minorMenus$config$na !== void 0 && _minorMenus$config$na.length ? minorMenus[config.name].children[0].name : undefined,
              "actived": config.name === selectedMinorMenuIndex,
              "hasSubMenu": config.children && !!config.children.length && config.children.some(function (x) {
                return !x.hide;
              }),
              "itemNum": config.children ? config.children.filter(function (x) {
                return !x.hide;
              }).length : 0
            },
            "on": {
              "click": function click(i) {
                return handleMinorMenuSelectedChanged(i, undefined, config);
              }
            },
            "class": _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuItemClassName(theme)
          }, [config.icon ? h("i", {
            "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.iconClassName, config.icon)
          }) : null, h("span", [(0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(config.title)]), config.status ? h("div", {
            "on": {
              "click": function click(e) {
                return handleClickStatus(e, config);
              }
            },
            "class": _style__WEBPACK_IMPORTED_MODULE_18__.statusWrapperClassName
          }, [h("div", {
            "class": _style__WEBPACK_IMPORTED_MODULE_18__.statusRectClassName
          }, [h("div", {
            "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.statusClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)("navbar_minor", statusOpen.includes(config.name) ? 'open' : 'close'))
          })])]) : null, config.children && config.children.length && config.children.some(function (x) {
            return !x.hide;
          }) ? h(_splat_menu__WEBPACK_IMPORTED_MODULE_12__.SubMenu, {
            "slot": 'submenu'
          }, [config.children.map(function (x, j) {
            return !x.hide ? h(_splat_menu__WEBPACK_IMPORTED_MODULE_12__.SubMenuItem, {
              "attrs": {
                "aItem": aItem,
                "index": x.name,
                "actived": x.name === selectedSubMenuIndex
              },
              "key": j,
              "on": {
                "click": function click(i) {
                  return handleSubMenuSelectedChanged(i, undefined, x);
                }
              },
              "class": _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuItemClassName
            }, [aItem ? h("a", {
              "attrs": {
                "href": "".concat((0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.routerModeUrl)(_this11.$router)).concat(x.name.replace(/:/g, '/'))
              },
              "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.subItemLinkClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('SubMenuItem', 'aItem'))
            }, [(0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(x.title), x.status ? h("div", {
              "on": {
                "click": function click(e) {
                  return handleClickStatus(e, x);
                }
              },
              "class": _style__WEBPACK_IMPORTED_MODULE_18__.statusWrapperClassName
            }, [h("div", {
              "class": _style__WEBPACK_IMPORTED_MODULE_18__.statusRectClassName
            }, [h("div", {
              "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.statusClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)("navbar_minor", statusOpen.includes(x.name) ? 'open' : 'close'))
            })])]) : null]) : null, !aItem ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(x.title) : null, x.status && !aItem ? h("div", {
              "on": {
                "click": function click(e) {
                  return handleClickStatus(e, x);
                }
              },
              "class": _style__WEBPACK_IMPORTED_MODULE_18__.statusWrapperClassName
            }, [h("div", {
              "class": _style__WEBPACK_IMPORTED_MODULE_18__.statusRectClassName
            }, [h("div", {
              "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.statusClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)("navbar_minor", statusOpen.includes(x.name) ? 'open' : 'close'))
            })])]) : null]) : null;
          })]) : null]) : null;
        }) || null;
      };

      var majorMenu = function majorMenu() {
        return h((_splat_menu__WEBPACK_IMPORTED_MODULE_12___default()), {
          "attrs": {
            "direction": _splat_menu__WEBPACK_IMPORTED_MODULE_12__.Direction.horizontal
          }
        }, [majorMenuItem(), majorMoreMenuItem()]);
      };

      var minorMenu = function minorMenu() {
        return h((_splat_menu__WEBPACK_IMPORTED_MODULE_12___default()), {
          "attrs": {
            "direction": _splat_menu__WEBPACK_IMPORTED_MODULE_12__.Direction.vertical,
            "verticalMenuMaxWidth": minorMaxWidth
          },
          "key": selectedMajorMenu ? selectedMajorMenu.name : ''
        }, [h("div", {
          "slot": 'header'
        }, [selectedMajorMenu && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.lazy)(selectedMajorMenu.title)]), minorMenuItem()]);
      };

      return h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('sl-id-navbar__container', _style__WEBPACK_IMPORTED_MODULE_18__.menuContainerClassName)
      }, [hideMajorMenu ? null : h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('sl-id-navbar__major-menu', _style__WEBPACK_IMPORTED_MODULE_18__.majorMenuClassName(theme))
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.logoClassName, minorMaxWidth && _style__WEBPACK_IMPORTED_MODULE_18__.logoMaxWidthClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('navbar', 'logo'))
      }, [this.$slots.logo]), h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_18__.menuItemContainerClassName
      }, [majorMenu()]), this.$slots.operation ? h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.operationContainerClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('navbar', 'operation'))
      }, [this.$slots.operation]) : null]), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('sl-id-navbar__bottom-content', _style__WEBPACK_IMPORTED_MODULE_18__.bottomContentClassName)
      }, [hideMinorMenu ? null : h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuWrapperClassName
      }, [h("transition", {
        "on": {
          "beforeEnter": this.handleBeforeEnter,
          "enter": this.handleEnter,
          "beforeLeave": this.handleBeforeLeave,
          "leave": this.handleLeave
        },
        "attrs": {
          "enterActiveClass": _style__WEBPACK_IMPORTED_MODULE_18__.MinorMenuActive,
          "leaveActiveClass": _style__WEBPACK_IMPORTED_MODULE_18__.MinorMenuActive
        }
      }, [minorMenuActive ? h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('sl-id-navbar__minor-menu', _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuClassName, minorMaxWidth ? _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuMaxWidthClassName : _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuNormalWidthClassName(theme, i18nInjection.lang))
      }, [minorMenu(), minorMenuAppend && minorMenuAppend()]) : null]), minorMenuShrink ? h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButton,
        "on": {
          "click": this.handleMoveMinorMenu,
          "mouseenter": this.handleMouseenter,
          "mouseleave": this.handleMouseleave
        }
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonTopClassName, this.minorButtonHover && _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonTopHoverClassName)
      }), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonMiddleClassName, this.minorButtonHover && _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonMiddleHoverClassName)
      }, [h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('iconfont icon-zhankai', _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonIconClassName, !minorMenuActive && _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonIconRotateClassName)
      })]), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonBottomClassName, this.minorButtonHover && _style__WEBPACK_IMPORTED_MODULE_18__.minorMenuButtonBottomHoverClassName)
      })]) : null]), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('sl-id-navbar__right-content', _style__WEBPACK_IMPORTED_MODULE_18__.rightContentClassName),
        "key": 'right-content'
      }, [hideZone ? null : h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.zoneClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('navbar', 'zone_wrapper'))
      }, [h((_splat_operation_zone__WEBPACK_IMPORTED_MODULE_14___default()), {
        "attrs": {
          "stripFirst": stripFirst,
          "filterWhiteBkg": filterWhiteBkg,
          "minorMenuShrinkButton": minorMenuShrinkButton,
          "minorMenuShrink": !minorMenuActive
        },
        "on": {
          "shrinkClick": function shrinkClick() {
            return _this11.handleMoveMinorMenu();
          }
        }
      })]), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_18__.routeViewClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('navbar', 'routeView'))
      }, [reloading ? null : h("router-view")])])])]);
    }
  }, {
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.i18nInjection) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }
    }
  }]);

  return Navbar;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_21__.Component);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_17__.NavbarGetter)(_store__WEBPACK_IMPORTED_MODULE_17__.Getters.Navbar)], Navbar.prototype, "navbarConfig", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_17__.NavbarGetter)(_store__WEBPACK_IMPORTED_MODULE_17__.Getters.StatusOpen)], Navbar.prototype, "statusOpen", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_17__.NavbarGetter)(_store__WEBPACK_IMPORTED_MODULE_17__.Getters.MinorMenuAppend)], Navbar.prototype, "minorMenuAppend", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "stripFirst", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "hideMinorMenu", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "hideMajorMenu", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "hideZone", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "minorMenuShrink", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)({
  default: false
})], Navbar.prototype, "minorMaxWidth", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "minorMenuShrinkButton", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "minorStatusText", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "statusSettingPath", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)({
  default: 0
})], Navbar.prototype, "more", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "aItem", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "filterWhiteBkg", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Prop)()], Navbar.prototype, "beforePushRoute", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Emit)('menuShrinked')], Navbar.prototype, "onMenuShrinked", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Watch)('$route', {
  immediate: true
})], Navbar.prototype, "handleRouteChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Provide)()], Navbar.prototype, "reloadRouterView", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Inject)({
  from: 'i18nInjection',
  default: null
})], Navbar.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Provide)('i18nInjection')], Navbar.prototype, "i18nProvider", void 0);

Navbar = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_20__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_10___default())]
})], Navbar);
/* harmony default export */ __webpack_exports__["default"] = (Navbar);

/***/ }),

/***/ "./src/store/constants.ts":
/*!********************************!*\
  !*** ./src/store/constants.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Getters": function() { return /* binding */ Getters; },
/* harmony export */   "Mutations": function() { return /* binding */ Mutations; }
/* harmony export */ });
var Getters;

(function (Getters) {
  Getters["Navbar"] = "Navbar";
  Getters["StatusOpen"] = "StatusOpen";
  Getters["MinorMenuAppend"] = "MinorMenuAppend";
})(Getters || (Getters = {}));

var Mutations;

(function (Mutations) {
  Mutations["Navbar"] = "UpdateNavbar";
  Mutations["StatusOpen"] = "StatusOpen";
  Mutations["MinorMenuAppend"] = "MinorMenuAppend";
})(Mutations || (Mutations = {}));

/***/ }),

/***/ "./src/store/getters.ts":
/*!******************************!*\
  !*** ./src/store/getters.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getters": function() { return /* binding */ getters; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");


var _getters;


var getters = (_getters = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_1__.Getters.Navbar, function (state) {
  return state.configs;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_1__.Getters.StatusOpen, function (state) {
  return state.statusOpen;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_1__.Getters.MinorMenuAppend, function (state) {
  return state.minorMenuAppend;
}), _getters);

/***/ }),

/***/ "./src/store/index.ts":
/*!****************************!*\
  !*** ./src/store/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "moduleName": function() { return /* binding */ moduleName; },
/* harmony export */   "ns": function() { return /* binding */ ns; },
/* harmony export */   "nsHelper": function() { return /* binding */ nsHelper; },
/* harmony export */   "NavbarGetter": function() { return /* binding */ NavbarGetter; },
/* harmony export */   "NavbarMutation": function() { return /* binding */ NavbarMutation; },
/* harmony export */   "Getters": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_5__.Getters; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_5__.Mutations; },
/* harmony export */   "factory": function() { return /* binding */ factory; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./src/utils.ts");
/* harmony import */ var _getters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getters */ "./src/store/getters.ts");
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mutations */ "./src/store/mutations.ts");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vuex */ "vuex");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vuex-class */ "vuex-class");
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(vuex_class__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");





var moduleName = 'navbar';
var ns = (0,vuex_class__WEBPACK_IMPORTED_MODULE_4__.namespace)(moduleName);
var nsHelper = (0,vuex__WEBPACK_IMPORTED_MODULE_3__.createNamespacedHelpers)(moduleName);
var NavbarGetter = ns.Getter;
var NavbarMutation = ns.Mutation;

function factory(store, configs) {
  var initialStore = {
    configs: configs ? (0,_utils__WEBPACK_IMPORTED_MODULE_0__.extractRoutes)(configs) : [],
    statusOpen: [],
    minorMenuAppend: undefined
  };
  store.registerModule(moduleName, {
    getters: _getters__WEBPACK_IMPORTED_MODULE_1__.getters,
    mutations: _mutations__WEBPACK_IMPORTED_MODULE_2__.mutations,
    namespaced: true,
    state: initialStore
  });
}

/***/ }),

/***/ "./src/store/mutations.ts":
/*!********************************!*\
  !*** ./src/store/mutations.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mutations": function() { return /* binding */ mutations; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");


var _mutations;


var mutations = (_mutations = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.Navbar, function (store, value) {
  store.configs = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.StatusOpen, function (store, value) {
  store.statusOpen = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.MinorMenuAppend, function (store, value) {
  store.minorMenuAppend = value;
}), _mutations);

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "menuContainerClassName": function() { return /* binding */ menuContainerClassName; },
/* harmony export */   "majorMenuClassName": function() { return /* binding */ majorMenuClassName; },
/* harmony export */   "logoClassName": function() { return /* binding */ logoClassName; },
/* harmony export */   "logoMaxWidthClassName": function() { return /* binding */ logoMaxWidthClassName; },
/* harmony export */   "menuItemContainerClassName": function() { return /* binding */ menuItemContainerClassName; },
/* harmony export */   "operationContainerClassName": function() { return /* binding */ operationContainerClassName; },
/* harmony export */   "bottomContentClassName": function() { return /* binding */ bottomContentClassName; },
/* harmony export */   "minorMenuWrapperClassName": function() { return /* binding */ minorMenuWrapperClassName; },
/* harmony export */   "minorMenuClassName": function() { return /* binding */ minorMenuClassName; },
/* harmony export */   "minorMenuNormalWidthClassName": function() { return /* binding */ minorMenuNormalWidthClassName; },
/* harmony export */   "minorMenuMaxWidthClassName": function() { return /* binding */ minorMenuMaxWidthClassName; },
/* harmony export */   "minorMenuButton": function() { return /* binding */ minorMenuButton; },
/* harmony export */   "minorMenuButtonTopClassName": function() { return /* binding */ minorMenuButtonTopClassName; },
/* harmony export */   "minorMenuButtonTopHoverClassName": function() { return /* binding */ minorMenuButtonTopHoverClassName; },
/* harmony export */   "minorMenuButtonMiddleClassName": function() { return /* binding */ minorMenuButtonMiddleClassName; },
/* harmony export */   "minorMenuButtonMiddleHoverClassName": function() { return /* binding */ minorMenuButtonMiddleHoverClassName; },
/* harmony export */   "minorMenuButtonBottomClassName": function() { return /* binding */ minorMenuButtonBottomClassName; },
/* harmony export */   "minorMenuButtonBottomHoverClassName": function() { return /* binding */ minorMenuButtonBottomHoverClassName; },
/* harmony export */   "minorMenuButtonIconClassName": function() { return /* binding */ minorMenuButtonIconClassName; },
/* harmony export */   "minorMenuButtonIconRotateClassName": function() { return /* binding */ minorMenuButtonIconRotateClassName; },
/* harmony export */   "minorMenuItemClassName": function() { return /* binding */ minorMenuItemClassName; },
/* harmony export */   "rightContentClassName": function() { return /* binding */ rightContentClassName; },
/* harmony export */   "zoneClassName": function() { return /* binding */ zoneClassName; },
/* harmony export */   "routeViewClassName": function() { return /* binding */ routeViewClassName; },
/* harmony export */   "majorMenuIconClassName": function() { return /* binding */ majorMenuIconClassName; },
/* harmony export */   "iconClassName": function() { return /* binding */ iconClassName; },
/* harmony export */   "MinorMenuActive": function() { return /* binding */ MinorMenuActive; },
/* harmony export */   "statusRectClassName": function() { return /* binding */ statusRectClassName; },
/* harmony export */   "statusWrapperClassName": function() { return /* binding */ statusWrapperClassName; },
/* harmony export */   "statusClassName": function() { return /* binding */ statusClassName; },
/* harmony export */   "cloudSubMenuClassName": function() { return /* binding */ cloudSubMenuClassName; },
/* harmony export */   "majorMoreMenuItemClassName": function() { return /* binding */ majorMoreMenuItemClassName; },
/* harmony export */   "majorMoreActivityClassName": function() { return /* binding */ majorMoreActivityClassName; },
/* harmony export */   "visibleDropClassName": function() { return /* binding */ visibleDropClassName; },
/* harmony export */   "majorMoreDropIconClassName": function() { return /* binding */ majorMoreDropIconClassName; },
/* harmony export */   "majorMoreDropItemClassName": function() { return /* binding */ majorMoreDropItemClassName; },
/* harmony export */   "subItemLinkClassName": function() { return /* binding */ subItemLinkClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_4__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var menuContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.layerParent, {
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100)
});
var majorMenuClassName = function majorMenuClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.attachToTop, csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, {
    height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.majorMenuHeight),
    background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarColors.themeMajorMenu(theme).toString()
  });
};
var logoClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.content, {
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.minorMenuWidth),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.majorMenuHeight)
});
var logoMaxWidthClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.minorMenuMaxWidth))
});
var menuItemContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flex, {// overflow: 'hidden',
});
var operationContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.content, {
  marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24)
});
var bottomContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  paddingTop: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.majorMenuHeight),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  boxSizing: 'border-box',
  display: 'flex'
});
var minorMenuWrapperClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  position: 'relative'
});
var minorMenuClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.attachToLeft, {
  position: 'relative',
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarColors.minorMenu.toString(),
  zIndex: 1,
  boxSizing: 'border-box',
  borderRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.border)({
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarColors.border.toString(),
    style: 'solid',
    width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
  })
});
var minorMenuNormalWidthClassName = function minorMenuNormalWidthClassName(theme, lang) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.themeMinorWidth(theme, lang))
  });
};
var minorMenuMaxWidthClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.minorMenuMaxWidth)
});
var minorMenuButton = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  position: 'absolute',
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(50),
  left: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(10),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(40),
  zIndex: 1,
  cursor: 'pointer'
});
var minorMenuButtonTopClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: 0,
  height: 0,
  borderBottom: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(9), " solid #e9e9e9"),
  borderRight: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(10), " solid transparent"),
  borderBottomRightRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(6),
  position: 'absolute'
});
var minorMenuButtonTopHoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  borderBottom: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(9), " solid #999")
});
var minorMenuButtonMiddleClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(10),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(30),
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(5),
  borderTopRightRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(7),
  borderBottomRightRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(7),
  background: '#e9e9e9',
  position: 'absolute'
});
var minorMenuButtonMiddleHoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  background: '#999'
});
var minorMenuButtonBottomClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: 0,
  height: 0,
  bottom: 0,
  borderTop: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(9), " solid #e9e9e9"),
  borderRight: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(10), " solid transparent"),
  borderTopRightRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(6),
  position: 'absolute'
});
var minorMenuButtonBottomHoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  borderTop: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(9), " solid #999")
});
var minorMenuButtonIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12),
  position: 'absolute',
  left: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-5),
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(7),
  color: 'white',
  transform: 'scale(0.4) rotate(90deg)',
  transitionDuration: '0.3s',
  transitionProperty: 'transform'
});
var minorMenuButtonIconRotateClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  transform: 'scale(0.4) rotate(270deg)'
});
var minorMenuItemClassName = function minorMenuItemClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(_objectSpread(_objectSpread({}, _splat_constant__WEBPACK_IMPORTED_MODULE_1__.colorTransition), {}, {
    position: 'relative',
    $nest: {
      '&:hover': {
        color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarColors.themeHighlightFont(theme).toString()),
        cursor: 'pointer'
      }
    }
  }));
};
var rightContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.layerParent, csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.vertical, {
  overflowY: 'auto',
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  minHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.majorMenuHeight),
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100)
});
var zoneClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.content, {});
var routeViewClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flex, {
  overflowY: 'auto'
});
var majorMenuIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.NavbarSizes.majorMenuIconMargin)
});
var iconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12)
});
var MinorMenuActive = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  transition: 'all .2s',
  overflow: 'hidden'
});
var statusRectClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16),
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(2)
});
var statusWrapperClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  position: 'absolute',
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(50),
  right: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(9),
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(32),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(32),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transform: 'translateY(-50%)',
  cursor: 'pointer',
  $nest: {
    '&:hover': {
      $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, ".".concat(statusRectClassName), {
        background: '#E9E9E9'
      })
    }
  }
});
var statusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(6),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(6)
});
var cloudSubMenuClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  borderRadius: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonSizes.cloudButtonRadius
});
var majorMoreMenuItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)(0, 12), {
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100)
});
var majorMoreActivityClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0, 12), {
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  cursor: 'pointer',
  $nest: {
    '& > span': {
      marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(9),
      fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(14)
    },
    '&:hover': {
      backgroundColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.mainDark.toString(),
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.white.toString()
    }
  }
});
var visibleDropClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  backgroundColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.mainDark.toString(),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.white.toString(),
  $nest: {
    '& i': {
      transform: (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(180))
    }
  }
});
var majorMoreDropIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.iconTransition, {
  display: 'inline-block',
  transform: (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(0))
});
var majorMoreDropItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(195),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(48),
  display: 'flex',
  alignItems: 'center',
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(14),
  $nest: {
    '&:hover': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primary.toString()
    }
  }
});
var subItemLinkClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  position: 'relative',
  display: 'inline-block',
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  textDecoration: 'none',
  color: 'inherit'
});

/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "./src/utils.ts":
/*!**********************!*\
  !*** ./src/utils.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "extractRoutes": function() { return /* binding */ extractRoutes; }
/* harmony export */ });
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_0__);


function isMetaRouteHubConfig(config) {
  return !(0,_splat_constant__WEBPACK_IMPORTED_MODULE_0__.isDef)(config.name);
}

function getRouteConfigName(config) {
  return isMetaRouteHubConfig(config) ? config.meta.name : config.name;
}

function extractRoutes(routes) {
  if (!routes) return undefined;
  return routes.filter(function (x) {
    return x.component;
  }).map(function (x) {
    return {
      name: getRouteConfigName(x),
      title: x.meta.title || getRouteConfigName(x),
      icon: x.meta.icon,
      hide: x.meta.hide,
      status: x.status,
      confirmText: x.confirmText,
      cancelText: x.cancelText,
      children: x.children && extractRoutes(x.children)
    };
  });
}

/***/ }),

/***/ "./src/asset/splat.png":
/*!*****************************!*\
  !*** ./src/asset/splat.png ***!
  \*****************************/
/***/ (function(module) {

module.exports = "data:image/png;base64,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";

/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "@splat/button":
/*!*************************************************************************!*\
  !*** external {"commonjs":"@splat/button","commonjs2":"@splat/button"} ***!
  \*************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_button__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/dialog":
/*!*************************************************************************!*\
  !*** external {"commonjs":"@splat/dialog","commonjs2":"@splat/dialog"} ***!
  \*************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_dialog__;

/***/ }),

/***/ "@splat/dropdown":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/dropdown","commonjs2":"@splat/dropdown"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_dropdown__;

/***/ }),

/***/ "@splat/form":
/*!*********************************************************************!*\
  !*** external {"commonjs":"@splat/form","commonjs2":"@splat/form"} ***!
  \*********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_form__;

/***/ }),

/***/ "@splat/form-item":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/form-item","commonjs2":"@splat/form-item"} ***!
  \*******************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_form_item__;

/***/ }),

/***/ "@splat/iconfont":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/iconfont","commonjs2":"@splat/iconfont"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_iconfont__;

/***/ }),

/***/ "@splat/inject-flash":
/*!*************************************************************************************!*\
  !*** external {"commonjs":"@splat/inject-flash","commonjs2":"@splat/inject-flash"} ***!
  \*************************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_inject_flash__;

/***/ }),

/***/ "@splat/input":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/input","commonjs2":"@splat/input"} ***!
  \***********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_input__;

/***/ }),

/***/ "@splat/menu":
/*!*********************************************************************!*\
  !*** external {"commonjs":"@splat/menu","commonjs2":"@splat/menu"} ***!
  \*********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_menu__;

/***/ }),

/***/ "@splat/operation-zone":
/*!*****************************************************************************************!*\
  !*** external {"commonjs":"@splat/operation-zone","commonjs2":"@splat/operation-zone"} ***!
  \*****************************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_operation_zone__;

/***/ }),

/***/ "@splat/status":
/*!*************************************************************************!*\
  !*** external {"commonjs":"@splat/status","commonjs2":"@splat/status"} ***!
  \*************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_status__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "vuex":
/*!*******************************************************!*\
  !*** external {"commonjs":"vuex","commonjs2":"vuex"} ***!
  \*******************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vuex__;

/***/ }),

/***/ "vuex-class":
/*!*******************************************************************!*\
  !*** external {"commonjs":"vuex-class","commonjs2":"vuex-class"} ***!
  \*******************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vuex_class__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js":
/*!*****************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
  \*****************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js":
/*!*********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js ***!
  \*********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArrayLimit; }
/* harmony export */ });
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js":
/*!****************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js ***!
  \****************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray.js":
/*!**************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray.js ***!
  \**************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithHoles.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js");
/* harmony import */ var _iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArrayLimit.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableRest.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js");




function _slicedToArray(arr, i) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(arr) || (0,_iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__["default"])(arr, i) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(arr, i) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js":
/*!***************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
  \***************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Getters": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.Getters; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.Mutations; },
/* harmony export */   "NavbarGetter": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.NavbarGetter; },
/* harmony export */   "NavbarMutation": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.NavbarMutation; },
/* harmony export */   "factory": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.factory; },
/* harmony export */   "moduleName": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.moduleName; },
/* harmony export */   "ns": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.ns; },
/* harmony export */   "nsHelper": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.nsHelper; },
/* harmony export */   "extractRoutes": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_3__.extractRoutes; },
/* harmony export */   "Logo": function() { return /* reexport safe */ _logo__WEBPACK_IMPORTED_MODULE_4__["default"]; }
/* harmony export */ });
/* harmony import */ var _navbar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./navbar */ "./src/navbar.tsx");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./store */ "./src/store/index.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils */ "./src/utils.ts");
/* harmony import */ var _logo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logo */ "./src/logo.tsx");




/* harmony default export */ __webpack_exports__["default"] = (_navbar__WEBPACK_IMPORTED_MODULE_0__["default"]);

}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map